export const datosPersonales = {
  REQUIRED_NAME_MESSAGE: 'Ingresa tu nombre',
  REQUIRED_LASTNAME_MESSAGE: 'Ingresa tu apellido',
  REQUIRED_COUNTRY_MESSAGE: 'Ingresa tu nacionalidad',
  REQUIRED_EMAIL_MESSAGE: 'Ingresa un correo electrónico valido',
  INVALID_EMAIL_MESSAGE: 'El correo electrónico que ingresaste no es válido',
  INVALID_PHONE_MESSAGE: 'El número de teléfono que ingresaste no es válido',
  REQUIRED_PHONE_MESSAGE: 'Ingresa tu número de teléfono',
  ACCOUNT_EMAIL_TOOLTIP: 'Este correo será utilizado para la creación de la cuenta en el portal privado'
};

export const datosComercio = {
  REQUIRED_ECONOMICACTIVITY_MESSAGE: 'Selecciona la actividad economica inscrita en el SII.',
  REQUIRED_CATEGORY_MESSAGE: 'Selecciona la categoria a la que pertenece tu comercio.',
  REQUIRED_RAZON_MESSAGE: 'Ingresa el nombre o la razón social de tu comercio.',
  REQUIRED_FANTASYNAME_MESSAGE: 'Ingresa el nombre de fantasía de tu comercio',
  REQUIRED_DESCRIPTION_MESSAGE: 'Ingresa la descripción',
  REQUIRED_ESTATE_MESSAGE: 'Ingresa la región',
  REQUIRED_CITY_MESSAGE: 'Ingresa la comuna',
  REQUIRED_ADDRESS_MESSAGE: 'Ingresa tu dirección (Avenida / Calle / Pasaje)',
  REQUIRED_STREETNUMBER_MESSAGE: 'Ingresa el número de calle',
  REQUIRED_LOCALNUMBER_MESSAGE: 'Ingresa el número de local o departamento',
  REQUIRED_RAZONSOCIAL_MESSAGE: 'Ingresa tu razón social',
  NOMBRE_FANTASIA_TOOLTIP: '<img src="assets/images/Voucher.png" alt="nombre_fantasia"></br></br>Es el nombre de tu negocio o local que aprecerá en el voucher de comprobante de la venta.'
};

export const datosEmpresa = {
  REQUIRED_ECONOMICACTIVITY_MESSAGE: 'Selecciona la actividad economica inscrita en el SII.',
  REQUIRED_CATEGORY_MESSAGE: 'Selecciona la categoria a la que pertenece tu empresa.',
  REQUIRED_RAZON_MESSAGE: 'Ingresa el nombre o la razón social de tu empresa.',
  REQUIRED_FANTASYNAME_MESSAGE: 'Ingresa el nombre de fantasía de tu empresa',
  REQUIRED_DESCRIPTION_MESSAGE: 'Ingresa la descripción',
  REQUIRED_ESTATE_MESSAGE: 'Ingresa la región',
  REQUIRED_CITY_MESSAGE: 'Ingresa la comuna',
  REQUIRED_ADDRESS_MESSAGE: 'Ingresa tu dirección (Avenida / Calle / Pasaje)',
  REQUIRED_STREETNUMBER_MESSAGE: 'Ingresa el número de calle',
  REQUIRED_LOCALNUMBER_MESSAGE: 'Ingresa el número de local o departamento',
  REQUIRED_RAZONSOCIAL_MESSAGE: 'Ingresa tu razón social',
  RAZON_SOCIAL_TOOLTIP: 'Es el nombre jurídico de tu empresa, el cual lo puedes encontrar en los documentos legales.',
  NOMBRE_FANTASIA_TOOLTIP: '<img src="assets/images/Voucher.png" alt="nombre_fantasia"></br></br>Es el nombre de tu negocio o local que aprecerá en el voucher de comprobante de la venta.'
};

export const datosSocios = {
  REQUIRED_NAME_MESSAGE: 'Ingresa el nombre del socio',
  REQUIRED_LASTNAME_MESSAGE: 'Ingresa el apellido del socio',
  REQUIRED_COUNTRY_MESSAGE: 'Ingresa la nacionalidad del socio',
  REQUIRED_EMAIL_MESSAGE: 'Ingresa un correo electrónico valido',
  INVALID_PHONE_MESSAGE: 'El número de teléfono que ingresaste no es válido',
  REQUIRED_PHONE_MESSAGE: 'Ingresa tu número de teléfono'
};

export const configuracionProducto = {
  REQUIRED_URL_MESSAGE: 'Ingresa dirección web de tu empresa',
  REQUIRED_NAME_MESSAGE: 'Ingresa el nombre',
  REQUIRED_LASTNAME_MESSAGE: 'Ingresa el apellido',
  REQUIRED_EMAIL_MESSAGE: 'Ingresa el correo electrónico',
  REQUIRED_PHONE_MESSAGE: 'Ingresa el número de teléfono',
  REQUIRED_PAY_MESSAGE: 'Ingresa el nombre del pago',
  REQUIRED_URL_CONTACT_MESSAGE: 'Ingresa dirección web de tu empresa',
  REQUIRED_NAME_CONTACT_MESSAGE: 'Ingresa el nombre',
  REQUIRED_LASTNAME_CONTACT_MESSAGE: 'Ingresa el apellido',
  REQUIRED_EMAIL_CONTACT_MESSAGE: 'Ingresa un correo electrónico válido',
  REQUIRED_PHONE_CONTACT_MESSAGE: 'Ingresa el número de teléfono',
  REQUIRED_MIN_LENGTH_PHONE_NUMBER: 'El número de teléfono que ingresaste no es válido',
  REQUIRED_AMOUNT_MESSAGE: 'Ingresa un monto'
};

export const cuentaBancaria = {
  REQUIRED_RUTEMPRESA_MESSAGE: 'Ingresa RUT de la empresa',
  REQUIRED_RUTTITULAR_MESSAGE: 'Ingresa RUT del titular de la cuenta',
  INVALID_RUT_MESSAGE: 'Ingresa un RUT válido',
  REQUIRED_FANTASYNAME_MESAGGE: 'Ingresa el nombre de fantasía de tu comercio.',
  REQUIRED_RAZONSOCIAL_MESSAGE: 'Ingresa tu nombre',
  REQUIRED_NAME_MESSAGE: 'Ingresa tu nombre',
  REQUIRED_LASTNAME_MESSAGE: 'Ingresa primer apellido',
  REQUIRED_BANK_MESSAGE: 'Selecciona el banco',
  REQUIRED_COUNTTIPE_MESSAGE: 'Selecciona el tipo de cuenta',
  REQUIRED_COUNTNUMBER_MESSAGE: 'Ingresa número de cuenta'
};

export const rut = {
  INVALID_RUT_MESSAGE: 'Ingresa un RUT válido',
  REQUIRED_RUT_MESSAGE: 'Ingresa RUT'
};
